import React, { useState, Suspense } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import useEffectLocation from "../hooks/useEffectLocation";

import './style.scss';
import Scrollbar from "smooth-scrollbar";
import MainDemo from "../views/home/MainDemo";
import WorkTow from "../views/WorkTow";
import About from "../views/About";
import Contact from "../views/Contact";
import World from "../views/World";
import NotFound from "../views/NotFound";

const Router = () => {

    const [transPage, setTransPage] = useState("in");
    const scrollbar: React.MutableRefObject<null | Scrollbar> = useSelector(state => state.scrollbar);

    const location = useEffectLocation((l) => {
        setTransPage("out");
    })

    const onAnimateEnd = () => {
        if (transPage !== "out") return;
        scrollbar.current?.scrollTo(0, 0, 0);
        window.scrollTo({ left: 0, top: 0 });
        setTransPage("in");
    }


    return (

        <div id="dsn-content" className={`dsn-transition-page dsn-animate-${transPage}`}
            onAnimationEnd={onAnimateEnd}
        >
            <Suspense fallback={<div className="background-main h-100-v" />}>
                <Routes location={location}>

                    <Route path="/" element={<MainDemo />} />
                    {/* <Route path="/demo-2" element={<Demo2/>}/>
                    <Route path="/demo-3" element={<Demo3/>}/> */}

                    {/* <Route path="/slider" element={<SliderOne/>}/>
                    <Route path="/slider-2" element={<SliderTow/>}/>
                    <Route path="/slider-3" element={<SliderThree/>}/> */}

                    {/* <Route exact path="/portfolio" element={<Work/>}/> */}
                    <Route exact path="/portfolio" element={<WorkTow />} />
                    {/* <Route exact path="/portfolio/:slug" element={<ProjectDetails/>}/> */}

                    <Route exact path="/about" element={<About />} />
                    <Route exact path="/contact" element={<Contact />} />
                    <Route exact path="/map" element={<World />} />
                    <Route exact path="*" element={<NotFound/>} />
                </Routes>
            </Suspense>
        </div>


    );
}

export default React.memo(Router);